





















































































































































































































































































































































































































































































import Component from 'vue-class-component'
import Vue from 'vue'
import Input from '@/components/inputs/Input.vue'
import Select from '@/components/Select.vue'
import Switcher from '@/components/Switcher.vue'
import {
  EFacilityNcsDirectDepositAction,
  EFacilityResidentSpectialBalanceActionTypes,
  EUserPermissions,
  IFacility,
  IFacilityAdvancedSettings,
  IPayerType,
  IUser,
  EFacilityNcsDirectDepositOptions,
  IBatchTemplate,
  ETemplateType,
  EBatchTemplateFilterType,
  EBatchTemplateFilterPeriod,
  getIdFromEntityField,
  isNonEmptyArray
} from '@zunta/configurations'
import { User } from '@/classes/User'
import Api from '@/api'
import AddEditActivePayerTypeModal
  from '@/views/app/management/settings/pages/facility/batch/components/BatchPayerTypeModal.vue'
import { NoCache } from '@/decorators/NoCache'
import Confirm from '@/components/Confirm.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import ErrorMessages from '@/components/ErrorMessages.vue'
import MultiSelectV2 from '@/components/inputsV2/MultiSelectV2.vue'
import { getSelectContentLabel } from '@/utils/helpers'
import Editable from '@/components/inputsV2/Editable.vue'
import BatchFormTemplate from '@/views/app/management/settings/pages/facility/batch/components/BatchFormTemplate.vue'
import UploadLetterModal from '@/views/app/management/settings/pages/facility/batch/components/UploadLetterModal.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'

const range = require('lodash.range')

@Component({
  components: {
    ErrorMessages,
    Checkbox,
    Confirm,
    AddEditActivePayerTypeModal,
    Switcher,
    Input,
    Select,
    MultiSelectV2,
    Editable,
    BatchFormTemplate,
    LoaderWrapper,
  },
  props: {
    preValidate: { type: Boolean, default: false },
    isSetting: {
      default: false
    },
    showBillingDay: {
      default: true
    },
    showHeader: {
      default: true
    },
    batchItemProp: {
      type: Object,
    },
    manuallySelectedFacility: {
      type: Object,
    },
    batchIndex: {
      type: Number,
      default: null
    },
    batchesProp: {
      default: null
    },
  }
})

export default class BatchForm extends Vue {
  showPayerTypeModal = false
  showIncludePayersModal = false
  showConfirmDeleteModal = false
  user = Api.getUser() as User
  EUserPermissions: any = EUserPermissions
  batchData: any = {}
  selectedBatchPreset: any = 0
  batchPresetList: any[] = []
  fieldErrors = ['Field is required']
  fieldsTouched: any = {}
  EBatchTemplateFilterType = EBatchTemplateFilterType
  EBatchTemplateFilterPeriod = EBatchTemplateFilterPeriod
  ETemplateType = ETemplateType
  getSelectContentLabel = getSelectContentLabel
  ADD_LETTER_TRIGGER_VALUE = ETemplateType.LETTER_PDF
  ADD_MESSAGE_TRIGGER_VALUE = ETemplateType.MESSAGE

  emptyLetterObj: Partial<IBatchTemplate> = {
    id: undefined,
    facilityId: getIdFromEntityField(this.$props.manuallySelectedFacility),
    batchId: undefined,
    settingsId: undefined,
    template: undefined,
    type: ETemplateType.LETTER_PDF,
    filterType: EBatchTemplateFilterType.NONE,
    payers: null
  }

  emptyMessageObj: Partial<IBatchTemplate> = {
    id: undefined,
    facilityId: getIdFromEntityField(this.$props.manuallySelectedFacility),
    batchId: undefined,
    settingsId: undefined,
    template: undefined,
    type: ETemplateType.MESSAGE,
    filterType: EBatchTemplateFilterType.NONE,
    payers: null
  }

  letterTemplatesList: Partial<IBatchTemplate>[] = [{ ...this.emptyLetterObj }]
  messageTemplatesList: Partial<IBatchTemplate>[] = [{ ...this.emptyMessageObj }]

  @NoCache
  get payerTypes () {
    const payers = this.$props.batchItemProp.payersList && this.$props.batchItemProp.payersList
        ? this.$props.batchItemProp.payersList
        : this.$store.state.facility.payerTypes
    if (!this.batchData.payersSettings || !this.batchData.payersSettings.length) {
      return payers
    }
    return payers.map((payer: IPayerType) => {
      const savedPayer = this.batchData.payersSettings.find((p: IPayerType) => p.id === payer.id)
      if (!savedPayer) {
        return payer
      }
      return savedPayer
    })
  }

  get secondaryPayersList () {
    const payers = this.payerTypes.filter((item: any) => !String(item.id).includes(this.batchData.payers)) || []
    if (!this.batchData.secondaryPayersSettings || !this.batchData.secondaryPayersSettings.length) {
      return payers
    }
    return payers.map((payer: IPayerType) => {
      const savedPayer = this.batchData.secondaryPayersSettings.find((p: IPayerType) => p.id === payer.id)
      if (!savedPayer) {
        return payer
      }
      return savedPayer
    })
  }

  get payerTypesForTemplates () {
    if (isNonEmptyArray(this.batchData.payers!) || isNonEmptyArray(this.batchData.secondaryPayers!)) {
      const filterArray = (this.batchData.payers || []).concat(this.batchData.secondaryPayers || []).map(Number)
      return this.payerTypes.filter((item: any) => filterArray.includes(Number(item.id)))
    }
    return this.payerTypes
  }

  get listOfSettings () {
    if (this.batchPresetList && this.batchPresetList.length) {
      return this.batchPresetList
    }
    let list = this.$props.batchesProp ? this.$props.batchesProp
        .filter((batch: IFacilityAdvancedSettings) => batch.id !== this.$props.batchItemProp.id)
        .map((batch: IFacilityAdvancedSettings) => {
          return {
            key: batch.id,
            value: batch.id,
            content: batch.name
          }
        }) : []
    list.unshift({
      key: 'selectOrderBatch',
      value: null,
      content: ''
    })
    return list
  }

  get settingId () {
    return this.$props.batchItemProp.presetId
  }

  get areTemplatesLoading () {
    return this.$props.manuallySelectedFacility.areTemplatesLoading
  }

  toggleIncludePayersModal (flag: boolean) {
    this.showIncludePayersModal = flag
  }

  togglePayerTypeModal (flag: boolean) {
    this.showPayerTypeModal = flag
  }

  toggleConfirmDeleteModal (flag: boolean) {
    this.showConfirmDeleteModal = flag
  }

  updateBatchPreset (event: any) {
    this.selectedBatchPreset = event.value
    if (event.value === null) {
      this.setEmptyBatchData()
    } else {
      const preset = this.$props.batchItemProp.presets.find((item: any) => item.id === event.value)
      if (!preset.controlBalance) {
        preset.controlBalance = null
      }
      if (preset.includeAllPayers) {
        preset.payers = this.payerTypes.map((pt: IPayerType) => pt.id)
      }
      this.batchData = preset
    }
    if (event.value !== null && this.$props.batchItemProp.presets) {
      this.batchData.batchOrder = this.$props.batchItemProp.presets.findIndex((item: any) => item.id === event.value)
      this.batchData.presetId = this.selectedBatchPreset
    }
    this.save()
  }

  updateSelectedPayersList (value: any) {
    const payersIds = value ? value.map((p: IPayerType) => p.id) : value
    this.updateData('payers', payersIds)
    this.updateData('payersSettings', value)
    if (this.isFcc) {
      // const secondaryPayers = this.batchData.secondaryPayers ? this.batchData.secondaryPayers.filter((item: any) => this.batchData.payers.includes(item.id)) : []
      const secondaryPayersSettings = this.batchData.secondaryPayersSettings ? this.batchData.secondaryPayersSettings.filter((item: IPayerType) => !this.batchData.payers.includes(item.id)) : []
      this.updateSelectedSecondaryPayersList(secondaryPayersSettings)
    }
    this.togglePayerTypeModal(false)
  }

  updateSelectedSecondaryPayersList (value: any) {
    const payerIds = value ? value.map((item: IPayerType) => item.id) : null
    this.updateData('secondaryPayers', payerIds)
    this.updateData('secondaryPayersSettings', value)
    this.toggleIncludePayersModal(false)
    this.$set(this.batchData, 'payersToExclude', this.batchData.payersToExclude
      .filter((p: number) => !this.batchData.payers || !this.batchData.payers.map(Number).includes(Number(p)))
      .filter((p: number) => !this.batchData.secondaryPayers || !this.batchData.secondaryPayers.map(Number).includes(Number(p)))
    )
  }

  updatePayersToExclude (value: any) {
    this.updateData('payersToExclude', value)
  }

  updateDataIntoSelectFields (param: string, event: any) {
    this.updateData(param, event.value)
  }

  updateData (param: string, value: any) {
    this.toggleSelect(param)
    if (param === 'controlBalance' && parseInt(value) === 0) {
      value = null
    }
    this.$set(this.batchData, param, value)
    this.save()
  }

  toggleSelect (field: string) {
    this.$set(this.fieldsTouched, field, true)
  }

  save () {
    this.batchData.includeAllPayers = this.batchData.payers && this.batchData.payers.length ? this.payerTypes.length === this.batchData.payers.length : false
    const templates = this.letterTemplatesList
      .concat(this.messageTemplatesList)
      .filter((tpl: Partial<IBatchTemplate>) => tpl.template as number)

    const payload = {
      batch: { ...this.batchData },
      templates,
    }

    if (!this.batchData.name) {
      payload.batch.name = 'Batch #' + (typeof this.$props.batchIndex !== 'undefined' ? this.$props.batchIndex + 1 : 1)
    }
    if (this.batchData.id && this.$props.batchItemProp.presets) {
      const batchOrder = this.$props.batchItemProp.presets.findIndex((item: any) => item.id === this.batchData.id)
      payload.batch.batchOrder = batchOrder !== null && batchOrder !== undefined ? batchOrder + 1 : null
    }
    this.$emit('save', payload)
  }

  deleteBatch () {
    this.$emit('remove', this.$props.batchIndex)
    this.toggleConfirmDeleteModal(false)
  }

  get isPcc () {
    return this.selectedFacility.origin === 'PCC'
  }

  get isFcc () {
    return this.selectedFacility.isFcc
  }

  get facilityResidentBalanceActionsList () {
    return [{
      key: EFacilityResidentSpectialBalanceActionTypes.MARK_DO_NOT_BILL,
      value: EFacilityResidentSpectialBalanceActionTypes.MARK_DO_NOT_BILL,
      content: 'Mark as "Do Not Bill"'
    }, {
      key: EFacilityResidentSpectialBalanceActionTypes.SEND_OUT,
      value: EFacilityResidentSpectialBalanceActionTypes.SEND_OUT,
      content: 'Send Out'
    }, {
      key: EFacilityResidentSpectialBalanceActionTypes.DO_NOT_GENERATE_STATEMENT,
      value: EFacilityResidentSpectialBalanceActionTypes.DO_NOT_GENERATE_STATEMENT,
      content: 'Do Not Generate'
    }]
  }

  get listOfBillingDays () {
    return range(1, 32).map((day: number) => ({
      key: day,
      value: day,
      content: day < 29 ? day : `${day} or last month day`
    }))
  }

  get facilityResidentNcsCollectionActionList () {
    return this.facilityResidentBalanceActionsList.filter((item) => item.key !== EFacilityResidentSpectialBalanceActionTypes.MARK_DO_NOT_BILL)
  }

  get ncsDirectDepositActionsList () {
    return [{
      key: EFacilityNcsDirectDepositAction.INCLUDE_ON_STATEMENT,
      value: EFacilityNcsDirectDepositAction.INCLUDE_ON_STATEMENT,
      content: 'Include on Statement'
    }, {
      key: EFacilityNcsDirectDepositAction.DO_NOT_INCLUDE_ON_STATEMENT,
      value: EFacilityNcsDirectDepositAction.DO_NOT_INCLUDE_ON_STATEMENT,
      content: 'Do Not Include on Statement'
    }]
  }

  get monthsBackItems () {
    return range(-1, 25).map((day: number) => ({
      key: day,
      value: day,
      content: day === -1 ? 'Pre-bill' : day === 0 ? 'From Current' : day
    }))
  }

  get requireReviewOptions () {
    return [{
      key: 'yes',
      value: true,
      content: 'Yes'
    }, {
      key: 'no',
      value: false,
      content: 'No'
    }]
  }

  get selectedFacility (): IFacility {
    if (this.$props.manuallySelectedFacility) {
      return this.$props.manuallySelectedFacility
    }
    return this.$store.state.facility.selectedFacility
  }

  get facilityUsers () {
    return this.$store.state.user.users.filter((user: IUser) => {
      if (user.isAllFacilities) {
        return true
      }
      if (!this.selectedFacility || !this.selectedFacility.id) {
        return false
      }
      // @ts-ignore
      return user.facilities.includes(this.selectedFacility.id.toString())
    })
  }

  get dueDateOptionsList () {
    return [
      {
        key: 100,
        value: 100,
        content: 'Past Due'
      },
      {
        key: 101,
        value: 101,
        content: 'Upon Receipt'
      }
    ].concat(range(1, 32).map((day: number) => ({
      key: day,
      value: day,
      content: day < 29 ? day : `${day} or last month day`
    })))
  }

  get ncsDirectDepositOptionsList () {
    return [
      {
        key: EFacilityNcsDirectDepositOptions.START_DATE,
        value: EFacilityNcsDirectDepositOptions.START_DATE,
        content: 'NCS Direct Deposit Date'
      },
      {
        key: EFacilityNcsDirectDepositOptions.PREBILL,
        value: EFacilityNcsDirectDepositOptions.PREBILL,
        content: 'Prebill'
      },
      {
        key: EFacilityNcsDirectDepositOptions.PREBILL_1_MONTH,
        value: EFacilityNcsDirectDepositOptions.PREBILL_1_MONTH,
        content: 'Prebill and Current Month'
      },
      {
        key: EFacilityNcsDirectDepositOptions.PREBILL_2_MONTH,
        value: EFacilityNcsDirectDepositOptions.PREBILL_2_MONTH,
        content: 'Prebill, Current, and Last Month'
      }
    ]
  }

  get facilityUsersItems () {
    return this.facilityUsers.map((facilityUser: IUser) => ({
      key: facilityUser.id,
      value: facilityUser.id,
      content: `${facilityUser.firstName} ${facilityUser.lastName}`
    }))
  }

  get payersToExcludeOptions () {
    let payers = this.$props.batchItemProp.payersList
    const payersToOptionMap = (p: IPayerType) => {
      return {
        key: Number(p.id as number),
        // @ts-ignore
        value: p.id.toString(),
        content: p.payer_name
      }
    }
    if (!this.batchData.payers || !this.batchData.payers.length) {
      return []
    }
    if (!payers) {
      return []
    }
    return payers
      .filter((p: IPayerType) => !this.batchData.payers || !this.batchData.payers.map(Number).includes(p.id as number))
      .filter((p: IPayerType) => !this.batchData.secondaryPayers || !this.batchData.secondaryPayers.map(Number).includes(p.id as number))
      .map(payersToOptionMap)
  }

  getPayersString (items: any) {
    if (!items) {
      return ''
    }
    if (items.length === this.payerTypes.length) {
      return 'All'
    }
    const payers = items.map((item: any) => this.getPayerLabel(item))
    const str = payers.join(', ')
    return str.length < 80
        ? str
        : str.slice(0, 80) + '...'
  }

  getPayerTooltipLabel (items: any): string {
    if (items && items.length) {
      const payerList = items.map((item: any) => this.getPayerLabel(item))
      let text = '<ul class="tooltip-list">'
      payerList.forEach((payer: any) => {
        text += `<li class="tooltip-item">• ${payer}</li>`
      })
      text += '</ul>'
      return text
    }
    return ''
  }

  getPayerLabel (id: number) {
    const payer = this.$props.batchItemProp.presets
        ? this.$props.batchItemProp.payersList.find((pt: IPayerType) => pt.id === +id)
        : this.$store.state.facility.payerTypes.find((pt: IPayerType) => pt.id === +id)

    if (!payer) {
      return ''
    }
    return payer.payer_name
  }

  addTemplate (templateType: ETemplateType) {
    templateType === ETemplateType.MESSAGE
      ? this.messageTemplatesList.push({ ...this.emptyMessageObj })
      : this.letterTemplatesList.push({ ...this.emptyLetterObj })
  }

  addTemplateLetterFromUpload (templateId: number) {
    this.letterTemplatesList.push({ ...this.emptyLetterObj, template: templateId })
    this.letterTemplatesList = this.letterTemplatesList.filter((tpl: Partial<IBatchTemplate>) => tpl.template)
  }

  deleteTemplate (templateType: ETemplateType, index: number) {
    const templateList = templateType === ETemplateType.MESSAGE ? this.messageTemplatesList : this.letterTemplatesList
    if (templateList[index]) {
      templateList.splice(index, 1)
    }

    if (!templateList.length) {
      this.addTemplate(templateType)
    }
    this.save()
  }

  checkIfNewTemplate (triggerValue: ETemplateType, index: number) {
    if (![this.ADD_MESSAGE_TRIGGER_VALUE, this.ADD_LETTER_TRIGGER_VALUE].includes(triggerValue)) {
      return
    }
    const templateList = triggerValue === this.ADD_MESSAGE_TRIGGER_VALUE ? this.messageTemplatesList : this.letterTemplatesList
    templateList[index].template = undefined
    const route = this.$router.resolve({
      name: 'management-template',
      params: {
        templateId: 'new'
      },
      query: {
        type: triggerValue,
      }
    })
    this.$locationManager.openNewTab(route.href, true)
  }

  saveTemplate (template: Partial<IBatchTemplate>, index: number) {
    const templateList = template.type === ETemplateType.MESSAGE ? this.messageTemplatesList : this.letterTemplatesList
    templateList[index] = template
    this.save()
  }

  initBatchData () {
    if (this.$props.batchItemProp.presets) {
      this.batchData = this.$props.batchItemProp.batch
      const options = [{
        key: 'selectBatch',
        value: null,
        content: 'Select Batch'
      }]
      options.push(...this.$props.batchItemProp.presets.map((preset: any, index: any) => {
        return {
          key: preset.id,
          value: preset.id,
          content: preset.name ? preset.name : `Batch #${index + 1}`
        }
      }))
      this.batchPresetList = options
      this.save()
    } else {
      if (this.$props.batchItemProp.id) {
        this.batchData = this.$props.batchItemProp
      } else {
        this.setEmptyBatchData()
      }
    }
  }

  get batchTemplates () {
    return this.$props.manuallySelectedFacility.templates
  }

  beforeMount () {
    this.$watch('batchItemProp', this.initBatchData)
    this.initBatchData()
  }

  mounted () {
    this.$watch('manuallySelectedFacility.templates', () => {
      const batchTemplates = this.$props.manuallySelectedFacility.templates || []
      this.messageTemplatesList = batchTemplates.filter((tpl: Partial<IBatchTemplate>) => tpl.type === ETemplateType.MESSAGE)
      if (!this.messageTemplatesList.length) {
        this.addTemplate(ETemplateType.MESSAGE)
      }

      this.letterTemplatesList = batchTemplates.filter((tpl: Partial<IBatchTemplate>) => tpl.type !== ETemplateType.MESSAGE)
      if (!this.letterTemplatesList.length) {
        this.addTemplate(ETemplateType.LETTER)
      }
    })
  }

  setEmptyBatchData () {
    this.batchData = {
      monthsBack: undefined,
      payers: this.payerTypes.map((pt: IPayerType) => pt.id),
      billingContact: undefined,
      reviewUser: undefined,
      reviewStatementsBeforeMailing: true,
      name: 'Batch name',
      dueDate: undefined,
      zeroBalanceAction: undefined,
      negativeBalanceAction: undefined,
      controlBalance: undefined,
      controlBalanceAction: undefined,
      ncsCollectionAction: undefined,
      ncsDirectDepositAction: undefined,
      pccBillingCycleManager: undefined,
      printedStatementUser: undefined,
      secondaryPayers: [],
      batchToCheck: null,
      includePreviousBreakdown: false,
      includeAdjustmentsBreakdown: false,
      excludePaymentsWriteOff: false,
      payersSettings: [],
      secondaryPayersSettings: [],
      includeAllPayer: true
    }
  }
}

